import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=4f6b768c&"
var script = {}
import style0 from "./AddElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports